import Link from "next/link";
import "./testimonialCard.scss";
import Image from "next/image";
import Head from "next/head";
import { useIntl } from "react-intl";
import { truncateText } from "@/utils/truncateText";

export default function TestimonialCard({ testimonial }) {
  const intl = useIntl();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: testimonial?.username,
    image: testimonial?.img?.url,
    jobTitle: "Advisor",
  };
  return (
    <Link href={`/advisors/${testimonial?.slug}`}>
      <div className="testmonialCardWrapper hover:shadow-lg transition-all duration-300">
        <Head>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Head>
        <div className="bg-white rounded-xl p-4 shadow-sm hover:shadow-lg transition-all duration-300 text-center max-w-sm mx-auto">
          <Image
            loading="lazy"
            src={testimonial?.img?.url}
            alt="testimonial user image"
            width={100}
            height={100}
            className="w-[100px] h-[100px] mx-auto rounded-full object-cover"
          />
          <p className="mt-4 font-semibold text-lg">{testimonial?.username}</p>
          <div className="text-sm text-gray-600">
            <div>{testimonial?.city?.data?.name}</div>
            <div>{testimonial?.country?.data?.name}</div>
          </div>
          <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm">
            {intl.formatMessage({ id: "viewMore" })}
          </button>
        </div>
      </div>
    </Link>
  );
}
